// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MoUzV","importantInfo":"styles_importantInfo__MhZVk"};